import { render, staticRenderFns } from "./gen1.vue?vue&type=template&id=a5de591e&scoped=true"
import script from "./gen1.vue?vue&type=script&lang=js"
export * from "./gen1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5de591e",
  null
  
)

/* custom blocks */
import block0 from "./gen1.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports